import { useState } from "react";
import { PostgresResponseForMedicalPaOrders } from "../../../../data-model/postgresResponseForMedicalPaOrders";
import { MyMedicalPaOrdersTableData } from "../../../../data-model/tablesData";

/** Represents the loading, data, and error state for the My PA Orders table. */
export interface MyMedicalPaOrdersState {
  data?: PostgresResponseForMedicalPaOrders;
  loading?: boolean;
  error?: string;
  showinLineLoader?: boolean;
  totalCount?: number;
}
/**
 * Manages local state for the My PA Orders table: the raw Postgres response
 * (loading/data/error) and the derived table row data array.
 *
 * @returns State values and setters for myMedicalPaOrdersState and tableData
 */
export const useMyPaOrdersTableData = () => {
  const [tableData, setTableData] = useState<MyMedicalPaOrdersTableData[]>([]);
  const [myMedicalPaOrdersState, setMyMedicalPaOrdersState] =
    useState<MyMedicalPaOrdersState>({
      data: undefined,
      loading: false,
      error: undefined,
      showinLineLoader: false,
    });

  return {
    myMedicalPaOrdersState,
    setMyMedicalPaOrdersState,
    tableData,
    setTableData,
  };
};
